import { render, staticRenderFns } from "./LearningStory.vue?vue&type=template&id=4cd0b9f6&"
import script from "./LearningStory.vue?vue&type=script&lang=js&"
export * from "./LearningStory.vue?vue&type=script&lang=js&"
import style0 from "./LearningStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports